import { render, staticRenderFns } from "./signUpForm.vue?vue&type=template&id=bb6e94d0&"
import script from "./signUpForm.vue?vue&type=script&lang=js&"
export * from "./signUpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports